import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { SectionCard, EmptyState } from "@/components/common/Primitives";
import { Activity } from "lucide-react";

export default function AuditTrailPage() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/audit-trail").then(({ data }) => setRows(data)); }, []);
  return (
    <div className="space-y-4">
      <div>
        <div className="text-[11px] uppercase tracking-[0.16em] text-slate-500 font-semibold">Security</div>
        <h1 className="font-heading text-2xl md:text-3xl font-extrabold text-slate-900">Audit Trail</h1>
        <p className="text-sm text-slate-600 mt-1">System activity and audit lifecycle events.</p>
      </div>
      <SectionCard title="Recent Activity" subtitle={`${rows.length} events`}>
        {rows.length === 0 ? <EmptyState /> : (
          <div className="space-y-1">
            {rows.map((r, i) => (
              <div key={i} className="flex items-start gap-3 p-2.5 border border-slate-100 rounded-md hover:bg-slate-50 transition-colors">
                <div className="h-8 w-8 rounded-md bg-slate-100 text-slate-700 grid place-items-center shrink-0"><Activity size={13} /></div>
                <div className="flex-1">
                  <div className="text-sm font-semibold text-slate-900">{r.action}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{r.details ? JSON.stringify(r.details) : (r.audit_id ? `Audit ${r.audit_id}` : "")}</div>
                </div>
                <div className="text-[10px] text-slate-400 font-mono">{new Date(r.timestamp).toLocaleString()}</div>
              </div>
            ))}
          </div>
        )}
      </SectionCard>
    </div>
  );
}
